// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Router from './router';
import Axios from './utils/Axios';
import Store from './store';
import Filters from './filters';
import Session from "@/utils/Session";
import Global from '@/utils/Global';
import wx from "@/assets/js/jweixin";
// import wx from "weixin-js-sdk";
import 'bootstrap/dist/css/bootstrap.min.css';
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
import '@/assets/css/index.scss';
import footer from '@/components/footer.vue';
import footerNav from '@/components/footerNav.vue';
import { MessageBox,Toast } from 'mint-ui';

Vue.config.productionTip = false;

/* 引入组件 */
Vue.use(MintUI);
// 日期格式化
Vue.use(require('vue-moment'));
// 全局过滤器
Vue.use(Filters);
// 微信JSSDK
Vue.use(wx);

/* 注册内置对象 */
Vue.prototype.$http = Axios;
Vue.prototype.$session = Session;
Vue.prototype.$global = Global;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$toast = Toast;

/* 注册全局组件 */
Vue.component('my-footer', footer);
Vue.component('my-footer-nav', footerNav);

// 实例化Vue
new Vue({
  el: '#app',
  router: Router,
  store: Store,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js